import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private readonly DEVICE_ID_KEY = 'device_id';
  private deviceId: string;

  constructor() {
    const storedId = localStorage.getItem(this.DEVICE_ID_KEY);

    if (storedId) {
      this.deviceId = storedId;
    } else {
      this.deviceId = this.generateUUID();
      localStorage.setItem(this.DEVICE_ID_KEY, this.deviceId);
    }
  }

  getDeviceId(): string {
    return this.deviceId;
  }

  private generateUUID(): string {
    // Simple UUID generator
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      // tslint:disable-next-line: no-bitwise
      const r = (Math.random() * 16) | 0;
      // tslint:disable-next-line: no-bitwise
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}